import { blue, green, indigo, purple, served } from "./colors";

import type { PaletteColor } from "@mui/material/styles/createPalette";
import type { ColorPreset } from ".";

export const getPrimary = (preset?: ColorPreset): PaletteColor => {
	switch (preset) {
		case "blue":
			return blue;
		case "green":
			return green;
		case "indigo":
			return indigo;
		case "purple":
			return purple;
		case "served":
			return served;
		default:
			console.error(
				'Invalid color preset, accepted values: "served", "blue", "green", "indigo" or "purple"".',
			);
			return blue;
	}
};
